'use client';

import { useEffect } from 'react';

export default function SuppressRateLimitError() {
  useEffect(() => {
    const originalError = console.error.bind(console);
    console.error = (...args: any[]) => {
      const msg = args[0];
      if (
        typeof msg === 'string' && (msg.includes('rate limit') || msg.includes('Request rate limit'))
      ) {
        return;
      }
      if (msg instanceof Error && msg.message?.toLowerCase().includes('rate limit')) {
        return;
      }
      originalError(...args);
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      const reason = event.reason;
      const msg =
        typeof reason === 'string'
          ? reason
          : reason?.message ?? '';
      if (msg.toLowerCase().includes('rate limit')) {
        event.preventDefault();
      }
    };

    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      console.error = originalError;
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return null;
}
